export function addEncodedURIComponent(url, key, value) {
    if (!url || !key || !value) {
        return url;
    }

    return `${url}?${key}=${encodeURIComponent(value)}`
}